import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import { withCookies, Cookies } from 'react-cookie';
import isRequiredIf from '../modules/react-conditional-required';
import Cookie from '../../const/Cookie';

const propTypes = {
  cookies: PropTypes.instanceOf(Cookies).isRequired,
  data: PropTypes.object,
  updateData: PropTypes.object,
  callbackCookie: isRequiredIf(PropTypes.func, props => !props.callbackUpdate),
  callbackUpdate: isRequiredIf(PropTypes.func, props => !props.callbackCookie),
  callcenterMode: PropTypes.bool.isRequired
};

class LoginCookie extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      callcenterMode: false,
      loginDataKey: Cookie.LOGIN_DATA_KEY,
      cookieExpiration: global.env.COOKIE_LOGIN_EXPIRATION || 15
    };
  }

  componentWillMount() {
    if (this.props.callcenterMode) {
      this.setState({
        callcenterMode: true,
        loginDataKey: Cookie.CALLCENTER_LOGIN_DATA_KEY,
        cookieExpiration: global.env.CALLCENTER_COOKIE_LOGIN_EXPIRATION || 30
      });
    }
  }

  componentDidMount() {
    if (this.props.updateData) {
      this.updateCookie(this.props.updateData);
    } else {
      this.setCookie(this.props.data);
      this.getCookie();
    }
  }

  componentWillReceiveProps(nextProps) {
    const data = nextProps.data;
    if (data !== this.props.data) {
      this.setCookie(data);
      this.getCookie();
    }
  }

  setCookie(data) {
    const { cookies } = this.props;
    if (data) {
      data.expirationDate = data.expirationDate || this.getExpirationDate();
      const loginData = {
        accountId: data.accountId,
        accountType: data.accountType,
        pointsBalance: data.pointsBalance,
        customerId: data.customerId,
        firstName: data.firstName,
        lastName: data.lastName,
        customerStatus: data.customerStatus,
        username: data.username,
        ssoToken: data.ssoToken,
        birthDate: data.birthDate,
        gender: data.gender,
        email: data.email,
        address: data.address,
        document: data.document,
        phone: data.phone,
        mobile: data.mobile,
        userClassification: data.userClassification,
        expirationDate: data.expirationDate
      };
      cookies.set(this.state.loginDataKey, loginData, {
        path: '/',
        expires: new Date(data.expirationDate)
      });
    }
  }

  getCookie() {
    const { cookies } = this.props;

    if (this.props.callbackCookie) {
      this.props.callbackCookie(cookies.get(this.state.loginDataKey));
    }
  }

  updateCookie(data) {
    const { cookies } = this.props;
    const actualData = cookies.get(this.state.loginDataKey);
    if (actualData) {
      data = { ...actualData, ...data };
      data.expirationDate = data.expirationDate || this.getExpirationDate();
      cookies.set(this.state.loginDataKey, data, {
        path: '/',
        expires: new Date(data.expirationDate)
      });
      if (this.props.callbackUpdate) {
        this.props.callbackUpdate(cookies.get(this.state.loginDataKey));
      }
    } else {
      this.props.callbackUpdate();
    }
  }

  getExpirationDate() {
    return Moment()
      .add(this.state.cookieExpiration, 'minutes')
      .toDate()
      .toISOString();
  }

  render() {
    return null;
  }
}

LoginCookie.propTypes = propTypes;

export default withCookies(LoginCookie);



// WEBPACK FOOTER //
// ./src/components/loginCookie/LoginCookie.jsx